module.exports = __webpack_public_path__ + "assets/pdf/PrivacyPolicy.2373e44e.pdf";